import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

const SchedulePostMessage = () => {
  const classes = useStyles();
  return (
    <Box className={classes.scheduleMessage}>
      <Typography fontWeight="bold">
        This is how your post will look like once posted
      </Typography>
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  scheduleMessage: {
    background: 'rgba(246, 246, 246, 0.76)',
    padding: theme.spacing(3),
    textAlign: 'center',
    fontSize: '14px',

    display: 'block',
    color: '#3c3c3c',
    '& p': {
      fontWeight: 'bold',
    },
  },
}));

export default SchedulePostMessage;
